import { useT } from '../i18n/i18n';
import { Spinner } from './Spinner';

export function FullscreenSpinner({ label }: { label?: string }) {
  const t = useT();
  const text = label ?? t('common.loading');
  return (
    <div style={{ height: '100%', display: 'grid', placeItems: 'center', color: 'var(--text-2)' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
        <Spinner size={28} label={text} />
        <span aria-hidden="true">{text}</span>
      </div>
    </div>
  );
}
